export default __webpack_public_path__ + "static/media/KZ.T.08.2302.8f5f89d5.svg";